<script lang="ts" setup>
import type {
  CardChefProps,
  EditorialGalleryHoverProps,
} from '@design-system/components/Editorial/EditorialGalleryHover.props'
import type { UIMediaProps } from '@design-system/components/UI/UIMedia.props'
import type { EditorialGalleryHover } from '@integration-layer/ampliance/schemas/editorial-gallery-hover-schema.localized'

const props = defineProps<{
  deliveryId: string
  locale: string
  vse?: string
  content?: EditorialGalleryHover
}>()

const data = await useComponentResponse<EditorialGalleryHover>(props)

const transformedData: EditorialGalleryHoverProps = {
  title: data.value?.title ?? '',
  subtitle: data.value?.subtitle ?? '',
  bgColor: data.value?.bgColor ?? 'white',
  textColor: data.value?.textColor ?? 'black',
  iconPlusColor: data.value?.iconPlusColor ?? 'black',
  carouselCard:
    data.value?.carouselCard.map(
      (card: any): CardChefProps => ({
        chefMedia: transformMedia(card.chefMedia) as UIMediaProps,
        chefName: card.chefName ?? '',
        link: card.link,
        hoverElement: card.hoverElement
          ? {
              description: card.hoverElement.description ?? '',
              logo: card.hoverElement.logo
                ? {
                    src:
                      card.hoverElement.logo.src.secure_url ||
                      card.hoverElement.logo.src.public_id ||
                      '',
                    alt: card.hoverElement.logo.alt ?? '',
                  }
                : undefined,
            }
          : undefined,
      })
    ) ?? [],
}
</script>

<template>
  <EditorialGalleryHover v-if="transformedData" v-bind="transformedData" />
</template>
